<template>
  <div id=""></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  created() {
    let comId = this.$common._getQuery("com_id");
    this.$common
      .http({
        url: "/api/supplier/account_info"
      })
      .then(res => {
        let isLogined = Number(res.data.data.is_logined);
        let isComplete = Number(res.data.data.is_complete);
        let openid = res.data.data.openid;
        if (isLogined == 1 && isComplete == 1) {
          // 跳转很作单位页面 rhwxWelcome
          this.$router.push({ path: "/rhwxWelcome" });
        } else if (isLogined == 0) {
          //rhwxLogin 带上openid
          this.$router.push({ path: "/rhwxLogin", query: { openid, comId } });
        } else if (isComplete == 0) {
          // rhwxInfoModify
          this.$router.push({ path: "/rhwxInfoModify" });
        }
      });
  }
};
</script>
<style lang="less">
@import "../assets/css/common";
</style>
